import { type CoverageTimelineRequest, type VoteTimelineRequest } from '@/app/result-time-machine/types';

export const voteTimelineKeys = {
	all: ['vote-timeline'] as const,
	timeline: (req: VoteTimelineRequest) => [...voteTimelineKeys.all, 'timeline', req] as const,
};

export const coverageTimelineKeys = {
	all: ['coverage-timeline'] as const,
	timeline: (req: CoverageTimelineRequest) => [...coverageTimelineKeys.all, 'timeline', req] as const,
};
